document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('tabs-component[data-default-button-link]').forEach((tabs) => {
    const button = tabs.querySelector('[data-featured-products-tab-button]');
    if (!button) return;

    const panels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));
    const defaultButtonLink = tabs.dataset.defaultButtonLink || '';

    const updateButtonLink = (index) => {
      const panel = panels[index];
      const buttonLink = panel?.dataset.buttonLink || defaultButtonLink;

      if (buttonLink) {
        button.setAttribute('href', buttonLink);
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        return;
      }

      button.removeAttribute('href');
      button.setAttribute('disabled', '');
      button.setAttribute('aria-disabled', 'true');
    };

    updateButtonLink(Number(tabs.dataset.selected) || 0);
    tabs.addEventListener('tabChange', (event) => {
      updateButtonLink(event.detail.selectedIndex);
    });
  });
});
